import { defaultPaletteColor } from '../constants-types/ColorPalettePicker.model';
import {
    PizzaObjectiveType,
    SelectedActivities,
    DerivedTeamName,
    BehavioralQuadrantRanks,
    StrategyQuadrant,
    IStrategyOrTeamSelection,
    DreamTeamFunctionType,
    DreamTeamCrossFunctionId,
    TeamImprovementId,
    DreamTeamAction,
    CustomAction,
    AlignmentResponseType,
    AlignmentResponseValue
} from '../constants-types/StrategyConstants';
import { Pattern } from './Pattern.model';
import { Person } from './Person.model';
import { ReferencePatternType } from './ReferencePatternType.model';

export class PizzaPlaygroundSession {
    readonly sessionId: string;
    sessionName: string;
    readonly personIdsWithColor: PizzaPlaygroundSessionPersonIdWithColor[];
    readonly selectedStrategyIds: string[];
    readonly createdDate: Date;
    readonly modifiedDate: Date;
    readonly teamId: string;
    objectiveType?: PizzaObjectiveType;
    selectedActivities?: SelectedActivities[];
    strategyType?: DerivedTeamName;
    teamType?: DerivedTeamName;
    teamFunctionType?: DreamTeamFunctionType;
    otherTeamFunction?: string;
    crossFunctionId?: DreamTeamCrossFunctionId;
    teamImprovementIds?: TeamImprovementId[];
    otherTeamImprovement?: string;
    isStrategyAutoSelectionEnabled?: boolean;
    teamActions?: DreamTeamAction[];
    customActions?: CustomAction[];
    actionTeamType: DerivedTeamName;
    shareLinkGuid: string;

    constructor(args: Partial<PizzaPlaygroundSession>) {
        Object.assign(this, args);
    }
}

// Problem children

export type StrategyOrTeamQuadrantMapper = {
    strategyQuestion: IStrategyOrTeamSelection;
    quadrant: StrategyQuadrant;
    isChecked: boolean;
};

export type PersonWithStrategyAlignment = {
    person: Person;
    ranks: BehavioralQuadrantRanks;
};

export class PizzaPlaygroundSessionPersonIdWithColor {
    personId: string;
    displayColor: number = defaultPaletteColor;
    isManager: boolean;
    firstName: string;
    lastName: string;
    selfPattern: Pattern;
    referencePatternType: ReferencePatternType;

    constructor(args: Partial<PizzaPlaygroundSessionPersonIdWithColor>) {
        Object.assign(this, args);
    }
}

export type teamActionRecommendations = {
    actionIds: number[];
};

export type preferredWorkStyle = {
    widestFecTrKey: string;
    secondWidestFecTrKey: string;
};

export type alignmentResponseData = {
    subjectId: string;
    userId: string;
    responseType: AlignmentResponseType;
    responseValue: AlignmentResponseValue;
};
